import config from "@config";

export const constants = {
  GARTNER_DOMAIN: "gartner.com",
  LOGO_ALT_TEXT: "Gartner Logo",
  API: {
    API_PATH: config.API_PATH,
  },
  ROUTES: {
    BASE_URL: "/data-hub",
    DASHBOARD: "/",
    MYLIBRARY:'/my-library'
  },
  HEADER: {
    SECONDARY_LOGO_LABEL: "DataHub",
    SIGN_OUT: "Sign Out",
    CLASSNAME: "delphi-header-wrapper",
  },
  LABELS: {
    STYLE_PREFIX: "delphi",
    HEADER: {
      SEARCH_PLACEHOLDER: "Search",
      SEARCH_ICON: "Search Icon"
    },
  },
  ERROR_CODE: {
    UNAUTHORIZED: 401,
  }
};
